// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"AssignTenantFragment_checkboxContainer__jPBQG","checkbox":"AssignTenantFragment_checkbox__QqJ-c"};